export default "__VITE_ASSET__CMY_v1qa__"